import Point from "@arcgis/core/geometry/Point";

export enum SectorColor {
    GREEN = "4",
    WHITE = "1",
    RED = "3",
    DARK = "0",
}

export enum SectorFallbackColor {
    GREEN = "#38a800FF",
    WHITE = "#ffd710FF",
    RED = "#ff0000FF",
    DARK = "#00000000",
}

/** Caps every field the sector description is typed into, so the three editors that write it
 *  - the definition table, the sector editor and the sector table - cannot disagree on how
 *  much text a sector may carry. Matches MAX_JOB_DESCRIPTION_LENGTH. */
export const MAX_SECTOR_DESCRIPTION_LENGTH = 255;

export interface Sector {
    globalid: string;
    lighthouseId: string;
    color?: SectorColor;
    startAngle?: number;
    innerRadius?: number;
    startLineLength?: number;
    endLineLength?: number;
    index: number;
    description?: string;
    nfs_status: number;
    nfs_status_line1: number;
    nfs_status_line2: number;
}

export interface LighthouseData {
    id: string;
    center: Point;
    sectors: Sector[];
    setState: ((value: LighthouseData) => void) | undefined;
}

export class DefaultSectorValues {
    static readonly defaultInnerRadius = 600;
    static readonly defaultLineLength = 1000;
}
